import React from 'react';
import { getDisplayName } from '../../../helpers/component';

/**
 * Checks whether its save to render
 * @param  {string|array<string>|function} required If string, it checks whether
 *                                                  the property is defined and truthy.
 *                                                  If array it will iterate over all items
 *                                                  and checks whether all tests are correct.
 *                                                  Function is for custom logic.
 * @param  {object} props                           Props of the component
 * @return {Boolean}
 * @todo  It may be handy to pass an object so that we actually are able to add type checks
 */
const isSafeToRender = (required, props) => {
  if (typeof required === 'string' && !props[required]) {
    return false;
  }

  if (typeof required === 'function' && !required(props)) {
    return false;
  }

  if (Array.isArray(required)) {
    return required.every(str => isSafeToRender(str, props));
  }

  return true;
};

/**
 * Higher order component to break the rendering workflow in case that required
 * properties are note defined. This may be usefull to prevent the server from crashing
 * in case of data that is only available or to handle loading phases.
 * @param  {string}    required Property that is required. At the moment only one string is
 *                              supported, we like to add arrays and functions as well.
 * @param  {Component} Fallback Fallback Component that should be rendered in case of invalid props.
 * @return {Component}
 */
const breakWithout = (required, Fallback = null) => (WrappedComponent) => {
  const ServiceBreakWithout = (props) => {
    if (isSafeToRender(required, props)) {
      return <WrappedComponent {...props} />;
    }

    if (Fallback) {
      return <Fallback {...props} />;
    }

    return Fallback;
  };

  ServiceBreakWithout.displayName = `ServiceBreakWithout(${getDisplayName(WrappedComponent)})`;
  ServiceBreakWithout.WrappedComponent = WrappedComponent;

  return ServiceBreakWithout;
};

export default breakWithout;
